import { NewPasswordResetForm } from "./password.types";

export const initialNewPasswordResetForm: NewPasswordResetForm = {
  password: "",
  confirmPassword: "",
};
